// Application

export const APP_SET_LANG = 'APP_SET_LANG';
